import { ProdcutEditComponent } from './product-edit.component';

export default ProdcutEditComponent;
